import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { UserService } from '../services/user.service';
import { CheckPassword } from '../services/validators/check-password.validator';
import { MatchFields } from '../services/validators/match-fields.validator'
import { fadeInUp } from '../services/animations/fadeInUp.animation'

import { JwtHelper } from 'angular2-jwt';

let jwtHelper: JwtHelper = new JwtHelper();

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    animations: [fadeInUp]
})
export class ResetPasswordPageComponent implements OnInit {

    resetPasswordForm: FormGroup;
    resetToken: string;
    showForm: Boolean = false;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private fbuilder: FormBuilder,
        private userService: UserService
    ) {
        this.resetPasswordForm = fbuilder.group({
            'password': [null, Validators.compose([Validators.required, CheckPassword])],
            'passwordConfirm': [null, Validators.compose([Validators.required, MatchFields('password')])]
        });

        this.resetToken = this.route.snapshot.params['token'];

        if (this.resetToken && !jwtHelper.isTokenExpired(this.resetToken)) {
            this.showForm = true;
            const body = {
                tokenFor: 'forgot',
                token: this.resetToken
            }
            this.userService.checkToken(body).subscribe(data => {
                if (!data) {
                    this.router.navigate(['login/reset-invalid']);
                }
            }, error => {
                if (error) {
                    this.router.navigate(['login/reset-invalid']);
                }
            });
        } else {
            this.router.navigate(['login/reset-invalid']);
        }
    }

    ngOnInit() {
    }

    submitResetPasswordForm(isValid: boolean, submission) {
        if (isValid) {
            submission.resetToken = this.resetToken;
            this.userService.resetPassword(submission).then(result => {
                this.router.navigate(['login/reset-success']);
            }).catch(error => {
            })
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/login/reset-password.component.ts